import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

/** The site-scoped navigation. A singleton on the site document, not a block somebody adds — see
 *  `types.ts`: editing the navigation must not dirty five pages. */
export const navbar: BlockDef = {
  type: 'navbar',
  v: 1,
  label: { en: 'Navigation', ar: 'شريط التنقّل' },
  scope: 'site',
  description:
    'The bar at the top of every page: the business name or logo, links to the pages, and one optional call-to-action button.',
  whenToUse: 'Exactly once per site. It is created with the site and appears on every page.',
  whenNotToUse: 'Never add a second one, and never use it for in-page section links — those are anchors on a page block.',
  variants: [
    { value: 'simple', label: { en: 'Links at the end', ar: 'الروابط في النهاية' } },
    { value: 'centered', label: { en: 'Links centred', ar: 'الروابط في الوسط' } },
    { value: 'minimal', label: { en: 'Name only', ar: 'الاسم فقط' } },
  ],
  fields: [
    { key: 'logo', label: { en: 'Business name', ar: 'اسم النشاط' }, type: { kind: 'text' }, default: EMPTY_TEXT, requiredForPublish: true },
    {
      key: 'items',
      label: { en: 'Links', ar: 'الروابط' },
      // Six is the point at which a phone stops being able to show them in one row. The editor is
      // where a customer discovers that, not the published site on their friend's phone.
      type: {
        kind: 'list',
        max: 6,
        item: [
          { key: 'label', label: { en: 'Text', ar: 'النص' }, type: { kind: 'text' }, default: EMPTY_TEXT },
          { key: 'link', label: { en: 'Goes to', ar: 'ينتقل إلى' }, type: { kind: 'link' }, default: { kind: 'none' } },
        ],
      },
      default: [],
    },
    { key: 'ctaLabel', label: { en: 'Button text', ar: 'نص الزر' }, type: { kind: 'text' }, default: EMPTY_TEXT, alongside: 'ctaLink' },
    { key: 'ctaLink', label: { en: 'Button goes to', ar: 'الزر ينتقل إلى' }, type: { kind: 'link' }, default: { kind: 'none' } },
    { key: 'sticky', label: { en: 'Stays visible when scrolling', ar: 'يبقى ظاهرًا عند التمرير' }, type: { kind: 'boolean' }, scope: 'tmpl', default: true },
  ],
}
